<template>
  <div class="photogallery" v-if="client">
    <div class="side">
      <img @click="goTo('/')" class="logo" :src="client.logo" />
      <h2 :style="{ color: coming_soon.font_color + ' !important' }">
        Photo Gallery
      </h2>
      <p :style="{ color: coming_soon.font_color + ' !important' }">
        {{ coming_soon.description }}
      </p>
    </div>
    <template v-if="coming_soon.images && coming_soon.images.length">
      <div class="gallery">
        <template v-for="(item, i) in coming_soon.images">
          <div
            v-if="!item.type || (item.type && item.type.includes('image'))"
            @click="showImages(i)"
            class="image"
            :style="{ backgroundImage: 'url(' + item.url + ')' }"
          ></div>
          <div
            v-if="item.type && item.type.includes('video')"
            @click="showImages(i)"
            class="image"
          >
            <video loop autoplay muted :src="item.url"></video>
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="gallery no-listings">
        <img src="@/assets/img/no-photo.svg" />
        <p>There are currently no new listings</p>
      </div>
    </template>

    <transition name="fade">
      <slider
        ref="slider"
        v-if="show_images"
        :slides="coming_soon.images"
        :show_text="true"
      ></slider>
    </transition>
  </div>
</template>

<script>
import { db, functions, analytics } from "@/config/firebaseInit";
import Slider from "@/components/Slider";

export default {
  name: "home",
  components: {
    Slider,
  },
  data() {
    return {
      client: this.$store.state.client,
      user: this.$store.state.user,
      coming_soon: this.$store.state.coming_soon,
      show_images: false,
    };
  },
  mounted() {},
  async created() {},
  watch: {},
  methods: {
    showImages(index) {
      this.show_images = true;
      setTimeout(() => {
        this.$refs.slider.current_index = index;
      }, 100);
    },
  },
};
</script>

<style lang="scss">
.photogallery {
  height: 100vh;
  width: 100vw;
  display: flex;
  .side {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 500px;
    padding: 50px !important;
    flex: none;
    .logo {
      width: 275px;
      margin: auto;
      margin-top: 50px;
      margin-bottom: 30px;
    }
    h2 {
      color: black;
      font-size: 51px;
      margin-bottom: 0;
    }
    p {
      font-size: 23px;
    }
  }
  .gallery {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    padding: 30px;
    .image {
      width: 32%;
      height: 323px;
      margin-bottom: 25px;
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
    }
    video {
      width: 100%;
    }
  }
}
</style>
